
/**
 * Run function (handler) in async
 * @param {function} func
 * @param {object} data
 * @param {string} type
 */
export function runAsync(func, data, type) {
    setTimeout(function() {
        func(data, type);
    }, 0);
}